<template>
  <FormLayout title="Choose a resource" @on-dismiss="handleDismiss">
    <vs-wrapper class="px-5">
      <resource-card
        v-for="id in resourceIds"
        :key="id"
        :resource-id="id"
        :link-to="{
          name: 'fvnext-info-panel',
          params: { id, source: 'resources' },
        }"
      />
    </vs-wrapper>
  </FormLayout>
</template>

<script setup lang="ts">
import ResourceCard from './ResourceCard.vue'
import FormLayout from '../common/FormLayout.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'

defineProps<{
  title?: string
  resourceIds: string[]
}>()

const emits = defineEmits<{
  (e: 'dismiss')
}>()

const handleDismiss = () => {
  emits('dismiss')
}
</script>
